<script setup>
import {useRoute} from "vue-router";
import {ref} from "vue";

const route = useRoute();

const tMenuValue = ref("dashboard")
if (route.path === '/') {
  tMenuValue.value = "dashboard"
}

if (route.path === '/a-group/list') {
  tMenuValue.value = "aGroup"
}

if (route.path === '/user/list') {
  tMenuValue.value = "user"
}






</script>

<template>
  <t-menu theme="light" :value="tMenuValue" style="margin-right: 50px" height="100vh">
    <template #logo>
<!--      <a href="/"><img width="180" class="logo" src="../assets/img/header-logo.png" alt="logo" /></a>-->
    </template>
    <a href="/">
      <t-menu-item value="dashboard">
          <template #icon>
            <t-icon name="dashboard" />
          </template>
          仪表盘
      </t-menu-item>
    </a>
    <a href="/a-group/list">
      <t-menu-item value="aGroup">
        <template #icon>
          <t-icon name="letters-a" />
        </template>
        A组
      </t-menu-item>
    </a>
    <a href="/user/list">
      <t-menu-item value="user">
        <template #icon>
          <t-icon name="user" />
        </template>
        管理员
      </t-menu-item>
    </a>
<!--    <a href="/case">-->
<!--      <t-menu-item value="case">-->
<!--        <template #icon>-->
<!--          <t-icon name="root-list" />-->
<!--        </template>-->
<!--        应用案例-->
<!--      </t-menu-item>-->
<!--    </a>-->
<!--    <t-menu-item value="control-platform">-->
<!--      <template #icon>-->
<!--        <t-icon name="control-platform" />-->
<!--      </template>-->
<!--      行业资讯-->
<!--    </t-menu-item>-->
<!--    <a href="/message">-->
<!--      <t-menu-item value="message">-->
<!--        <template #icon>-->
<!--          <t-icon name="precise-monitor" />-->
<!--        </template>-->
<!--        在线留言-->
<!--      </t-menu-item>-->
<!--    </a>-->
<!--    <t-menu-item value="user-circle">-->
<!--      <template #icon>-->
<!--        <t-icon name="user-circle" />-->
<!--      </template>-->
<!--      用户-->
<!--    </t-menu-item>-->
  </t-menu>
</template>

<style scoped>
a {
  text-decoration: none;
}
</style>
<style>
.t-menu__logo {
  background-color: #000;
}
</style>